import moment from "moment";
import { Cookies } from "react-cookie";
import CONSTANT from "./constant";

export const getAuthToken = () => {
  const token = getCookie(CONSTANT.cookie.token);
  return token;
};

export const getUserDetail = () => {
  const token = getCookie(CONSTANT.cookie.userDetail);
  return token;
};

export const setStorage = (key: string, value: any) => {
  localStorage.setItem(key, JSON.stringify(value));
};

export const getStorage = (key: string) => {
  const value: any = localStorage.getItem(key);
  return JSON.parse(value);
};

export const setCookie = (name: string, value: any) => {
  const cookies = new Cookies();
  const options: any = { path: "/" };
  if (window.location.hostname.endsWith("epieoffice.in")) {
    options.domain = ".epieoffice.in";
  }
  cookies.set(name, value, options);
};

export const getCookie = (name: string) => {
  const cookie = new Cookies();
  const value = cookie.get(name);
  return value;
};

export const removeAllCookies = () => {
  const cookies = document.cookie.split(";");
  for (const cookie of cookies) {
    const eqPos = cookie.indexOf("=");
    const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();
    document.cookie = name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
    document.cookie = name + "=; Path=/; Domain=.epieoffice.in; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
  }
};

export const onChange = (
  context: any,
  name: string,
  newValue: any,
  callback?: any
) => {
  context.setState(
    { [name]: { ...context.state[name], value: newValue } },
    callback && callback
  );
};

export const onArrayChange = (
  context: any,
  name: string,
  value: any,
  callback?: any
) => {
  const updatedValue = value;
  context.setState(
    { [name]: { ...context.state[name], value: updatedValue } },
    callback && callback
  );
};

export const setOptions = (
  context: any,
  name: string,
  value: any,
  callback?: any
) => {
  context.setState(
    { [name]: { ...context.state[name], options: value } },
    callback && callback
  );
};

export const clearOptions = (
  context: any,
  name: string,
  value: any,
  callback?: any
) => {
  context.setState(
    { [name]: { ...context.state[name], options: [] } },
    callback && callback
  );
};

export const setError = (
  context: any,
  name: string,
  error: string,
  callback?: any
) => {
  context.setState(
    { [name]: { ...context.state[name], error } },
    callback && callback
  );
};

export const setRequired = (
  context: any,
  name: string,
  newIsRequired: any,
  callback?: any
) => {
  context.setState(
    { [name]: { ...context.state[name], isRequired: newIsRequired } },
    callback && callback
  );
};

export const setShow = (
  context: any,
  name: string,
  newShow: any,
  callback?: any
) => {
  context.setState(
    { [name]: { ...context.state[name], show: newShow } },
    callback && callback
  );
};

export const isEmpty = (input: any) => {
  const dataType = typeof input;
  if (input === null || input === undefined) {
    return true;
  } else if (dataType === "string") {
    const parsedValue = input.replace(/ /g, "").replace(/(?:\r\n|\r|\n)/g, "");
    if (parsedValue.length === 0) {
      return true;
    }
  } else if (dataType === "object") {
    return Object.keys(input).length === 0;
  }
  return false;
};

export const validateForm = (context: any) => {
  const st = JSON.parse(JSON.stringify(context.state));
  let status = true;
  for (let key in st) {
    if (st.hasOwnProperty(key)) {
      const isRequired = st[key] ? st[key].isRequired : false;
      if (isRequired) {
        const name = st[key].name;
        const value = st[key].value;
        const type = typeof value;
        if (
          (value === null || value === undefined || value.length === 0) &&
          type !== "number"
        ) {
          status = false;
          setError(context, name, "   ");
        } else if (value.length > 0) {
          setError(context, name, "");
        } else if (type === "number") {
          setError(context, name, "");
        }
      }
    }
  }
  return status;
};

export const getAuthHeader = () => {
  const token = getCookie(CONSTANT.cookie.token);
  const header = {
    headers: { Authorization: `Bearer ${token}` },
  };
  return header;
};

export const getUploadFileHeader = () => {
  const token = getAuthToken();
  const header = {
    headers: {
      Authorization: "Bearer " + token,
      "content-type": "multipart/form-data",
    },
  };
  return header;
};

export const getSuperUserAuthHeader = () => {
  const token = localStorage.getItem(CONSTANT.cookie.superUserToken);
  const header = {
    headers: { Authorization: `Bearer ${token}` },
  };
  return header;
};

export const getDateParts = (input: any) => {
  const mDate = moment(input);

  return {
    date: mDate.format("DD"),
    month: mDate.format("MM"),
    monthName: mDate.format("MMM"),
    year: mDate.format("YYYY"),
    hour: mDate.format("h"),
    minute: mDate.format("mm"),
    seconds: mDate.format("ss"),
    amOrpm: mDate.format("A"),
    relativeTime: mDate.fromNow(),
  };
};

export const getDatePartsfromTimestamp = (input: any) => {
  const mDate = moment(input);

  return {
    date: mDate.date(),
    month: mDate.format("MMMM"),
    year: mDate.year(),
    hour: mDate.hour(),
    minute: mDate.minute(),
    seconds: mDate.seconds(),
  };
};

export const getTimeParts = (input: any) => {
  const mDate = moment(input, "HH:mm:ss");
  return {
    hour: mDate.format("h"),
    minute: mDate.format("mm"),
    seconds: mDate.format("ss"),
    amOrpm: mDate.format("A"),
  };
};

export const getTodaysDate = () => {
  const dtToday = new Date();
  let month = "";
  let day = "";
  const year = dtToday.getFullYear();

  if (dtToday.getMonth() + 1 < 10) {
    month = "0" + (dtToday.getMonth() + 1).toString();
  } else {
    month = (dtToday.getMonth() + 1).toString();
  }

  if (dtToday.getDate() < 10) {
    day = "0" + dtToday.getDate().toString();
  } else {
    day = dtToday.getDate().toString();
  }
  return { year, month, day };
};

export const validateEmail = (email: string) => {
  var re =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

export const sleep = (milliseconds: number) => {
  return new Promise((resolve) => setTimeout(resolve, milliseconds));
};

export const setValue = (
  context: any,
  name: string,
  value: any,
  callback?: any
) => {
  context.setState(
    { [name]: { ...context.state[name], value: value } },
    callback && callback
  );
};

export const removeCurrencySymbol = (value: any) => {
  return parseInt(
    value.replace(CONSTANT.static.currencySymbol, "")?.replace(",", "")
  );
};
